// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".comment-box {\n  background: white;\n  color: black;\n  min-height: 5vh;\n  max-height: 50vh;\n  overflow-y: scroll;\n  max-width: 120vh;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
